import { render, staticRenderFns } from "./count.vue?vue&type=template&id=85e9de0a"
import script from "./count.vue?vue&type=script&lang=js"
export * from "./count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports